<template>
	<div class="animated fadeIn ncmcodes--ncmcodes-list">
		<b-row id="ncmcodes-header-nav">
			<b-col md="6">
				<h1 id="ncmcodes-header-nav-txt">NCM Codes  <records-count :total="pageInfo.totalItems"/></h1>
			</b-col>
			<b-col md="6">
				<div class="buttons-panel">
					<b-button
						@click="add()"
						size="sm"
						title="Add"
						style="float: right;margin-bottom: 5px;"
					>
						<i class="fa fa-plus" aria-hidden="true"></i> Add Button
					</b-button>
					<grid-settings :gridId="gridId" :fields="fields" />
				</div>
			</b-col>
		</b-row>
		<b-row>
			<b-col>
				<div style="margin-top: 41px;" class="card">
					<div class="card-header">

					</div>
					<div class="card-body">
            <grid-component
              isResizable
              isReorderable
              isSortable
              :gridId="gridId"
              :pageable="pageable"
              :skip="pageInfo.pageSize * (pageInfo.pageNumber - 1)"
              :take="pageInfo.pageSize"
              :itemData="itemData"
              :pageSizes="pageInfo.pageSize"
              :totalItems="pageInfo.totalItems"
              :fields="fields"
              :sortBy="pageInfo.sortBy"
              :sortOrder="pageInfo.sortOrder"
              :sortMethod="sortGrid"
              :onEdit="pushToDetails"
              :styleCustom="'height: 800px'"
              @getData="onGetData"
              :isTblLoader="tblLoader"
              />
					</div>

				</div>
			</b-col>
		</b-row>
	</div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';
import { debounce } from 'lodash';

import { dateTime } from '@/shared/filters';
import { GRID_PAGE_SIZES, PAGE_SIZE, GRID_ID } from '@/shared/constants';
import { prepareColumnsData } from '@/shared/helpers';
import GridSettings from '@/shared/components/GridSettings';
import GridComponent from '@/shared/components/GridComponent';
import gridFields from './fields';

const SEARCH_DEBOUNCE_TIME = 750;

export default {
  components: {
    GridSettings,
    GridComponent
  },
  metaInfo: () => ({
    title: 'Ncmcodes',
  }),
  data() {
    return {
      prepareColumnsData,
      filtersVisible: false,
      fields: gridFields,
      gridId: GRID_ID.NCMCODES_GRID,
      pageable: {
        pageSizes: GRID_PAGE_SIZES,
      },
      		selectedRowItemId: 0,
    };
  },
  computed: {
    ...mapGetters('ncmcodes', [
      'ncmcodes',
      'pageInfo',
      'selectedItemId',
      'tblLoader',
    ]),
    ...mapGetters('account', ['gridSettingsById']),
    filterButtonName() {
      return this.filtersVisible ? 'Hide advanced' : 'Advanced';
    },
    gridSettings() {
      return this.gridSettingsById(this.gridId);
    },
    itemData() {
      if (this.ncmcodes == undefined || !this.ncmcodes.length) return [];
      return this.ncmcodes.map((ncmcode) => ({ ...ncmcode, selected: ncmcode.id === this.selectedRowItemId }));
    },
  },
  filters: {
    dateTime,
  },
  methods: {
    ...mapActions('ncmcodes', ['getAll', 'sortGrid', 'remove']),
    ...mapActions('account', ['saveGridSettings']),
    ...mapMutations('ncmcodes', ['setItem']),
    onRowClick: function(event) {
      this.edit(event.dataItem);
    },
    edit(item) {
      this.$router.push({ name: 'ncmcodes.edit', params: { id: item.id } });
    },
    add() {
      this.$router.push({ name: 'ncmcodes.add' });
    },
    onRowClick(row) {
      this.selectedRowItemId = row.dataItem.id;
      // const { id, detailsVisible } = row.dataItem;
      // this.select({ id, isChecked: !detailsVisible });
    },
    pushToDetails(row) {
      this.$router.push({
        name: 'ncmcodes.edit',
        params: { id: row.id },
      });
    },
    async onGetData(params) {
      await this.getAll(params);
    },
  },
  mounted() {
    this.setItem({ resource: 'pageInfo', payload: {...this.pageInfo, ...this.gridSettings.sort, ...this.gridSettings.pageSize} });

    this.getAll({});
  },
  beforeDestroy() {
    // this.select({ id: null, isChecked: false });
  },
};
</script>

<style lang="scss">
@import '@/assets/scss/_colors.scss';

#ncmcodes-header-nav {
    width: 100%;
    z-index: 1000;
    position: fixed;
    border-bottom: 1px solid rgb(200, 206, 211);
    background: #fff;
}

#ncmcodes-header-nav-txt {
  background-color: #fff;
  padding: 8px;
  font-size: 20px;
  margin: 0px;
}


.ncmcodes {
  &--ncmcodes-list {
    .tools > * {
      margin: 0 0 0 3px;
    }
    .b-pagination {
      justify-content: center;
    }
    .create-ultra-rfp {
      margin-top: 0.5em;
      margin-bottom: 1em;
    }
    table td {
      cursor: pointer;
    }
    .buttons-panel {
      text-align: right;
      margin-right: 30px;
      margin-top: 7px;
      .btn {
        margin-left: 5px;
      }

    }
    .clear-filter-button-container {
      margin-top: 12px;
      text-align: right;
    }
  }

  &--grid-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
}

.highlight {
  background: $rowSelection !important;
}

.b-pagination {
  justify-content: center;
}

.tools > * {
  margin: 0 0 0 3px;
}

#KendoGrid .k-virtual-scrollable-wrap table {
	min-width: 800px;
}
</style>
